import { createSlice } from "@reduxjs/toolkit";
import { rejectClaimItem } from "../../reducer/claimsRejectItem/claimsRejectItemReducer";

const initialState = {
  data: {},
  isLoading: false,
  error: null,
};

const rejectClaimItemSlice = createSlice({
  name: "rejectClaimItem",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(rejectClaimItem.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(rejectClaimItem.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload?.data || {};
      })
      .addCase(rejectClaimItem.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || action.error.message;
      });
  },
});

export default rejectClaimItemSlice.reducer;
